import React from 'react';
import Lottie from 'react-lottie';
import Box from '@material-ui/core/Box';

import animation from './animation.json';

interface ISearching {
  animationHeight?: number;
  animationWidth?: number;
  containerHeight?: string;
}

const Searching: React.FC<ISearching> = ({
  containerHeight = '50vh',
  animationHeight = 250,
  animationWidth = 250,
}) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
  };
  return (
    <Box display="flex" height={containerHeight} justifyContent="center" alignItems="center">
      <Lottie options={defaultOptions} height={animationHeight} width={animationWidth} />
    </Box>
  );
};

export { Searching };
